import {useEffect, useState} from "react";
import axiosInstance from "../../Helper/axiosInstance";
import {useParams} from "react-router-dom";

export const useCount = () => {
    const [count , setCount] = useState(0);
    const {id} = useParams();
    useEffect(() => {
     axiosInstance.get(`https://shadeventapi.noyanet.com/Event/GetEventMembers/${id}`).then(({data})=>{
        setCount(data.data);
    })
    }, [id]);
    return {
        count,
    }
}